export const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3003/api',
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:3003',
  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3004',
  APP_NAME: 'Client Data Manager',
  VERSION: '1.0.0'
};

export default config; 